/* Bijoux Kenza — collection page behaviour for the Shopify section (vanilla, no build).
   Cards are rendered in Liquid (snippets/bijoux-kenza-product-card.liquid); this filters/sorts them in place,
   drives the mobile sheet, toolbar hide-on-scroll, wishlist and AJAX add-to-cart.

   Wired to the theme rather than to the handoff's local stand-ins:
     · wishlist → 'at_wishlist', the key the header counter and /pages/wishlist read
     · follow   → not here: omes-brand-follow.js owns every [data-follow][data-brand]
     · cart     → the theme's <cart-drawer>, rendered from the add response as the PDP does
                  (assets/omes-product.js); the toast only shows when there is no drawer.
                  Pieces with a choice carry [data-quickview] and never reach the submit handler.
   Client-side filtering covers the products on the current page (per_page ≤ 48). */
(() => {
  const WK = 'at_wishlist';

  function init(root) {
    if (!root || root.dataset.bkInit === '1') return;
    root.dataset.bkInit = '1';
    const scope = root.closest('.shopify-section') || document;
    const $ = (s, r = scope) => r.querySelector(s), $$ = (s, r = scope) => [...r.querySelectorAll(s)];
    const grid = $('#bkc-grid'), chips = $('#bkc-chips'), ctrl = $('#bkc-controls'), ov = $('#bkc-ov'), sheet = $('#bkc-sheet'), toast = $('#bkc-toast'), empty = $('#bkc-empty');
    if (!grid || !ov) return;
    const colorSel = $('#bkc-color'), sortSel = $('#bkc-sort');
    const T = JSON.parse($('#bk-plp-i18n').textContent);
    const cards = $$('.pcard', grid), tile = $('.edtile', grid), after = +root.dataset.atelierAfter || 6;
    const st = { cat: 'all', color: 'all', sort: 'featured', sheet: false };
    const press = (el, on, cls = 'on') => { el.classList.toggle(cls, on); el.setAttribute('aria-pressed', String(on)); };
    const colorsOf = (c) => (c.dataset.colors || '').split('|');

    function render() {
      const vis = cards.filter((c) => (st.cat === 'all' || c.dataset.cat === st.cat) && (st.color === 'all' || colorsOf(c).includes(st.color)));
      const cmp = st.sort === 'price-asc' ? (a, b) => a.dataset.price - b.dataset.price : st.sort === 'price-desc' ? (a, b) => b.dataset.price - a.dataset.price : (a, b) => a.dataset.order - b.dataset.order;
      const sorted = vis.slice().sort(cmp);
      cards.forEach((c) => { c.hidden = !vis.includes(c); });
      sorted.forEach((c) => grid.appendChild(c));
      cards.filter((c) => c.hidden).forEach((c) => grid.appendChild(c));
      const pristine = st.cat === 'all' && st.color === 'all' && st.sort === 'featured';
      if (tile) { const show = pristine && sorted.length > after; root.classList.toggle('edit', show); tile.hidden = !show; if (show) grid.insertBefore(tile, sorted[after]); }
      empty.hidden = vis.length > 0;
      const hasF = st.cat !== 'all' || st.color !== 'all';
      $$('.fclear', root).forEach((b) => { b.hidden = !hasF; });
      $('.mfilter .dot', root).hidden = !hasF;
      $$('.chip[data-cat]', root).forEach((b) => press(b, b.dataset.cat === st.cat, 'active'));
      $$('.sh-chip[data-cat]', ov).forEach((b) => press(b, b.dataset.cat === st.cat));
      $$('[data-color]', ov).forEach((b) => press(b, b.dataset.color === st.color));
      $$('[data-sort]', ov).forEach((b) => b.classList.toggle('on', b.dataset.sort === st.sort));
      if (colorSel) colorSel.value = st.color;
      sortSel.value = st.sort;
      $('[data-apply]', ov).textContent = vis.length ? T.apply : T.applyEmpty;
    }

    const stickyTop = () => parseFloat(getComputedStyle(ctrl).top) || 0;
    function toTop() {
      const c = $('.catwrap', root); if (!c) return;
      const top = c.getBoundingClientRect().top + scrollY - ctrl.offsetHeight - stickyTop() - 8;
      if (scrollY > top + 4) scrollTo({ top, behavior: 'smooth' });
    }
    function centerChip() {
      const a = chips.querySelector('.chip.active');
      if (a && chips.scrollWidth > chips.clientWidth) chips.scrollTo({ left: a.offsetLeft - chips.offsetLeft - (chips.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
    }
    function setSheet(v) {
      st.sheet = v; ov.classList.toggle('open', v); ov.setAttribute('aria-hidden', String(!v));
      document.documentElement.style.overflow = v ? 'hidden' : '';
      if (v) { ctrl.classList.remove('hid'); $('.sh-x', sheet).focus({ preventScroll: true }); }
    }
    let tt;
    function showToast() { clearTimeout(tt); toast.classList.add('on'); tt = setTimeout(() => toast.classList.remove('on'), 1900); }

    function wlGet() { try { const v = JSON.parse(localStorage.getItem(WK) || '[]'); return Array.isArray(v) ? v.map(String) : []; } catch (e) { return []; } }
    function syncWish() { const ids = wlGet(); $$('.fav[data-fav]', grid).forEach((b) => press(b, ids.includes(b.dataset.fav))); }
    function toggleWish(id) {
      const ids = wlGet(), i = ids.indexOf(id);
      if (i > -1) ids.splice(i, 1); else ids.unshift(id);
      try { localStorage.setItem(WK, JSON.stringify(ids)); } catch (e) { /* private mode */ }
      syncWish();
      if (window.checkWishlist) { try { window.checkWishlist(); return; } catch (e) { /* fall through */ } }
      const n = document.querySelector('#wishlistItems'); if (n) n.textContent = ids.length;
    }

    scope.addEventListener('click', (e) => {
      const t = e.target.closest('button,[data-close-sheet]'); if (!t || !(root.contains(t) || ov.contains(t))) return;
      const d = t.dataset;
      if (d.fav) { e.preventDefault(); toggleWish(d.fav); return; }
      if (d.cat) { const prev = st.cat; st.cat = d.cat; render(); if (prev !== st.cat) centerChip(); if (!st.sheet) toTop(); return; }
      if (d.sort) { st.sort = d.sort; render(); return; }
      if (d.color) { st.color = st.color === d.color ? 'all' : d.color; render(); return; }
      if ('clear' in d) { Object.assign(st, { cat: 'all', color: 'all', sort: 'featured' }); render(); return; }
      if ('openSheet' in d) { setSheet(true); return; }
      if ('closeSheet' in d) { setSheet(false); return; }
      if ('apply' in d) { setSheet(false); toTop(); }
    });
    if (colorSel) colorSel.addEventListener('change', (e) => { st.color = e.target.value; render(); });
    sortSel.addEventListener('change', (e) => { st.sort = e.target.value; render(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && st.sheet && root.isConnected) setSheet(false); });

    // AJAX add to cart, single-variant pieces only. Falls back to a normal submit.
    root.addEventListener('submit', async (e) => {
      const f = e.target.closest('.add-form'); if (!f) return;
      e.preventDefault();
      const btns = $$('button', f); btns.forEach((b) => { b.disabled = true; });
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id: +f.querySelector('[name="id"]').value, quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        const r = await fetch(addUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        const j = await r.json();
        if (!r.ok || j.status) throw new Error(j.description || 'add failed');
        if (cart && typeof cart.renderContents === 'function' && j.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(j);
        } else {
          showToast();
        }
        if (window.OmesBundles) window.OmesBundles.reconcile();
        document.dispatchEvent(new CustomEvent('omes:cart:added', { detail: j }));
      } catch (err) { f.submit(); } finally { btns.forEach((b) => { b.disabled = false; }); }
    });

    // Mobile: sticky toolbar hides on scroll down, returns on scroll up (CSS only animates it ≤600px)
    let lastY = scrollY, hide = false;
    addEventListener('scroll', () => {
      if (!root.isConnected) return;
      const y = scrollY, dy = y - lastY; lastY = y;
      const past = $('.catwrap', root).getBoundingClientRect().top < 0;
      if (!past) hide = false; else if (dy > 8) hide = true; else if (dy < -8) hide = false;
      ctrl.classList.toggle('hid', hide && !st.sheet);
    }, { passive: true });

    // Mobile: swipe the sheet down by its handle/header to close (> 90px)
    let drag = null;
    [$('.sh-grab', sheet), $('.sh-head', sheet)].forEach((el) => {
      el.addEventListener('touchstart', (e) => { drag = { y: e.touches[0].clientY, dy: 0 }; sheet.style.transition = 'none'; }, { passive: true });
      el.addEventListener('touchmove', (e) => { if (!drag) return; drag.dy = Math.max(0, e.touches[0].clientY - drag.y); sheet.style.transform = `translateY(${drag.dy}px)`; }, { passive: true });
      el.addEventListener('touchend', () => { const d = drag; drag = null; sheet.style.transition = ''; sheet.style.transform = ''; if (d && d.dy > 90) setSheet(false); });
    });

    syncWish();
    render();
  }

  const boot = () => document.querySelectorAll('[data-bk-plp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // The theme editor re-renders a section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
